export default "__VITE_ASSET__Br$nkaCM__"